
import RequestService from "@/services/RequestService.js";

const addLead = function (lead, token) {
    const url = "https://www.rdstation.com.br/api/1.3/conversions";

    const body = lead;
    body.token_rdstation = token;
    const header = {
        "content-type": "application/json",
        "Accept": "application/json",
        "mode": 'no-cors'
    }

    return fetch(url, { headers: new Headers(header), method: 'POST', body: JSON.stringify(body) })
}

const createLead = function(lead) {
    // Create lead RD Station
    return RequestService().axiosRequest("POST", 'https://www.econodata.com.br/consulta-empresa/api/ecdt-rd-station/createLead', {
    "lead": lead,
    "cnvrid": 'simulador-leads-agendor-ecdt',
    "trfsrc": lead.trfsrc,
    "rdtrk": lead.rdtrk,
    "traffic_medium": lead.traffic_medium,
    "traffic_campaign": lead.traffic_campaign,
    })
}

export default { addLead, createLead };